import { PackingStatus, StockStatus } from "@gtpl/shared-models/common-models";
import { FgStockStatusEnum } from "@gtpl/shared-models/warehouse-management";
import { ApiProperty } from "@nestjs/swagger";

export class StockSoItemRequest {
    @ApiProperty()
    saleOrderItemId: number;
    @ApiProperty()
    location: number;
    @ApiProperty()
    stockType: StockStatus;
    @ApiProperty()
    pouchesShortage?: PackingStatus;
    @ApiProperty()
    cartonsShortage?: PackingStatus;
    @ApiProperty()
    productCategory?: string;
    @ApiProperty()
    packStyleId?: number;
}
